import Reveal from "@/components/Reveal";
import { MapPin, ExternalLink } from "lucide-react";

const CLASSES = [
  {
    group: "Crianças",
    age: "Até 12 anos",
    days: "SEGUNDA & QUINTA",
    time: "19:00 — 20:30",
    focus: "Disciplina, coordenação motora, respeito e fundamentos do BJJ.",
    img: "/assets/turma-kids.jpeg",
    alt: "Crianças da turma kids do Projeto Bonsai treinando no tatame",
    testid: "schedule-card-kids",
  },
  {
    group: "Adultos",
    age: "Iniciante e avançado",
    days: "SEGUNDA & QUINTA",
    time: "20:30 — 22:00",
    focus: "Condicionamento, defesa pessoal, técnica e espírito de equipe.",
    img: "/assets/turma-adultos.jpeg",
    alt: "Alunos adultos do Projeto Bonsai em treino de solo no tatame",
    testid: "schedule-card-adults",
  },
];

const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=R.+Jo%C3%A3o+Ferreira+da+Silva,+84+-+Al%C3%A9m+Ponte,+Sorocaba+-+SP,+18013-200";

export default function Schedule() {
  return (
    <section id="horarios" className="relative py-28 sm:py-36" data-testid="schedule-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-xs tracking-[0.3em] text-gold mb-4" data-testid="schedule-eyebrow">AULAS & HORÁRIOS</p>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight max-w-2xl" data-testid="schedule-title">
            Duas noites por semana. <span className="text-gold">Zero custo.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-6">
          {CLASSES.map((c, i) => (
            <Reveal key={c.group} delay={i * 0.15}>
              <article
                data-testid={c.testid}
                className="group relative rounded-2xl overflow-hidden border border-white/10 hover:border-gold/40 transition-all duration-500 hover:shadow-[0_0_50px_rgba(212,175,55,0.1)]"
              >
                <div className="relative h-56 overflow-hidden">
                  <img src={c.img} alt={c.alt} loading="lazy" className="w-full h-full object-cover grayscale-[40%] group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-surface via-surface/40 to-transparent" />
                  <span className="absolute top-4 left-4 font-mono text-xs tracking-[0.25em] bg-obsidian/80 backdrop-blur border border-gold/30 text-gold px-3 py-1.5 rounded-full">{c.days}</span>
                </div>
                <div className="relative bg-surface p-8">
                  <div className="flex items-baseline justify-between gap-4 flex-wrap">
                    <h3 className="font-display text-2xl font-bold">{c.group}</h3>
                    <p className="font-mono text-xl sm:text-2xl text-gold" data-testid={`${c.testid}-time`}>{c.time}</p>
                  </div>
                  <p className="font-mono text-xs tracking-widest text-zinc-500 mt-1">{c.age.toUpperCase()}</p>
                  <p className="mt-4 text-zinc-400 text-sm leading-relaxed">{c.focus}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6 bg-surface border border-white/10 rounded-2xl p-8" data-testid="schedule-location-card">
            <div className="flex gap-4 items-start">
              <div className="shrink-0 w-11 h-11 rounded-full border border-crimson/50 flex items-center justify-center text-crimson">
                <MapPin size={20} />
              </div>
              <div>
                <p className="font-mono text-xs tracking-[0.25em] text-zinc-500">ONDE TREINAMOS</p>
                <p className="font-display font-semibold text-lg mt-1" data-testid="schedule-address">R. João Ferreira da Silva, 84 — Além Ponte</p>
                <p className="text-sm text-zinc-400">Sorocaba — SP, 18013-200</p>
              </div>
            </div>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="schedule-maps-button"
              className="inline-flex items-center gap-2 font-display font-semibold text-sm border border-gold/40 text-gold px-6 py-3 rounded-full hover:bg-gold hover:text-obsidian transition-all duration-300"
            >
              Ver no Mapa <ExternalLink size={16} />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
